"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelCropParameter = exports.CollectionModelCropParameterMutator = void 0;
const cropParameter_state_1 = require("./cropParameter.state");
class CollectionModelCropParameterMutator {
    constructor(cropParameter) {
        this.cropParameter = cropParameter;
    }
    setValue(state) {
        this.cropParameter.collectionState.setFieldValue(this.cropParameter.instanceId, state);
    }
    /** Gives a shallow clone of the crop correction state */
    getValue() {
        return Object.assign({}, this.cropParameter.state);
    }
    /**
     * Remove the state of this crop correction
     * *Warning:* You will need to unlink & remove the crop correction from the list before destroying the state.
     * @see CollectionModelCropParameterStateMutator.remove
     */
    destroyState() {
        this.cropParameter.collectionState.setFieldValue(this.cropParameter.instanceId, null);
    }
    /**
     * Remove the crop correction,
     * This will unlink and destroy the crop correction and all associated values.
     *
     * @see CollectionModelCropParameterStateMutator.remove
     */
    remove() {
        this.cropParameter.cropParameterState.Mutator.remove(this.cropParameter);
    }
}
exports.CollectionModelCropParameterMutator = CollectionModelCropParameterMutator;
class CollectionModelCropParameter {
    constructor(state, cropParameterId, captureId) {
        this.instanceId = cropParameter_state_1.CollectionModelCropParameterState.cropParameterId(captureId, cropParameterId);
        this.id = cropParameterId;
        this.captureId = captureId;
        this.cropParameterState = state;
    }
    get state() {
        return this.collectionState.getFieldValue(this.instanceId);
    }
    get collectionState() {
        return this.cropParameterState.collection.state;
    }
    get isDeletable() {
        return true;
    }
}
exports.CollectionModelCropParameter = CollectionModelCropParameter;
//# sourceMappingURL=cropParameter.js.map